import { createSelector } from 'reselect';
import { entitiesSelector } from './issue-selector';

export const jpdDeliverLinkTypeIdSelector = createSelector(
	entitiesSelector,
	(entities) => entities.jpdDeliveryIssueLinkTypeId,
);
